/**
 * EventProgressBar component.
 */
import EventProgressBarContainer from '../../atoms/container/eventProgressBarContainer';
import EventProgressBarInnerBar from '../../atoms/container/eventProgressBarInnerBar';

interface Props {
  color?: string;
  percentage: number;
}

export default function EventProgressBar({ color, percentage }: Props) {
  return (
    <EventProgressBarContainer>
      <EventProgressBarInnerBar
        color={color}
        width={isNaN(percentage) ? 0 : percentage}
      />
    </EventProgressBarContainer>
  );
}
